
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PoPurOrderDialog extends Serenity.EntityDialog<PoPurOrderRow, any> {
        protected getFormKey() { return PoPurOrderForm.formKey; }
        protected getIdProperty() { return PoPurOrderRow.idProperty; }
        protected getLocalTextPrefix() { return PoPurOrderRow.localTextPrefix; }
        protected getNameProperty() { return PoPurOrderRow.nameProperty; }
        protected getService() { return PoPurOrderService.baseUrl; }
        protected getDeletePermission() { return PoPurOrderRow.deletePermission; }
        protected getInsertPermission() { return PoPurOrderRow.insertPermission; }
        protected getUpdatePermission() { return PoPurOrderRow.updatePermission; }


        protected form = new PoPurOrderForm(this.idPrefix);

        public countcall: number;
        public potypefg: number;
        public hide: number;
        public paycode: number;


        constructor() {
            super();

            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
                this.calcDataOnGrid();
            });


            this.form.CashOrTermfg.changeSelect2(async e => {
                // let idd = Q.toId(this.form.SupplierId.value)
                let y = this.form.CashOrTermfg.value
                console.log(y)
                if (y == "0") {
                    this.form.PayTermCode.set_readOnly(true);
                    this.form.PayTermCode.value = "Cash"


                } if (y == "1") {
                    this.form.PayTermCode.set_readOnly(false);
                }


            });
            this.form.ShipId.changeSelect2(async e => {
                var x: string = this.form.ShipId.value
                this.form.WhsId.value = null


                if (!Q.isEmptyOrNull(x)) {
                    let a = this.form.ShipId.value
                    let whs: string = Purchase.PoShipAddressRow.getLookup().itemById[a].WhsId;

                    this.form.DtList.whsid = whs
                    console.log(whs)
                    this.form.WhsId.value = whs
                    // this.form.DtList.WhsId = whs;

                    this.form.ShipName.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipName;
                    this.form.ShipLineAddress1.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress1;
                    this.form.ShipLineAddress2.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress2;
                    this.form.ShipLineAddress3.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress3;

                }
            });

            this.form.SupplierId.changeSelect2(async e => {
                var x: string = this.form.SupplierId.value
                Serenity.EditorUtils.setReadOnly(this.form.SalesVatTypes, false);
                Serenity.EditorUtils.setReadOnly(this.form.POTypeFg, false);
                this.form.Remark.value = null
                this.form.PurOrderAmt.value = 0

                if (!Q.isEmptyOrNull(x)) {
                    
                    this.form.RefDocNo1.set_readOnly(false);
                    this.form.DtList.supid = x
                    this.form.DtList.sup = x
                    
                    if (this.potypefg == 1) {
                        let b = Purchase.PoSupplierRow.getLookup().itemById[x].ConsignFg
                        this.form.BranchCode.value = Purchase.PoSupplierRow.getLookup().itemById[x].BranchCode ?? "";
                        let pp = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 37 && x.SysFg > 0)
                        if (b == 1) {
                            this.form.POTypeFg.value = "1";
                            if (pp != null) {
                                this.form.SalesVatTypes.value = "I"
                                this.form.DtList.salevattype = this.form.SalesVatTypes.value
                                this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                                // this.calcVat()
                            }

                        } else {
                            this.form.POTypeFg.value = "0";
                            if (pp != null) {
                                this.form.SalesVatTypes.value = "E"
                                this.form.DtList.salevattype = this.form.SalesVatTypes.value
                                this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                                // this.calcVat()
                            }
                        }

                    }
                    console.log(x + ":a")
                    if (this.paycode == 1) {
                        this.form.PayTermCode.value = Supplier.CsSupplierRow.getLookup().itemById[x].PayMethod ?? "";
                    }
                } else {
                    this.form.RefDocNo1.set_readOnly(true);
                }
            });

            this.form.SalesVatTypes.changeSelect2(async e => {
                let vatId = Q.toId(this.form.SalesVatTypes.value)
                if (vatId) {
                    this.form.DtList.salevattype = this.form.SalesVatTypes.value
                    this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                }
            });


            this.form.DiscText.change(e => {
                var discStr = Q.toId(this.form.DiscText.value);
                if (discStr) {
                    this.disamtalocate();

                }
            });
            this.form.DiscText.addValidationRule(this.uniqueName, e => {
                var totalAmt = this.form.TotalAmt.value;
                var disAmt = this.form.DiscAmt.value;
                if (totalAmt != null && disAmt != null && disAmt > 0 && disAmt > totalAmt) {
                    return "Discount can't be higher than total amount!";
                }
            });

            this.form.VatCode.changeSelect2(e => {
                var VatCode: string = Q.toId(this.form.VatCode.value);
                if (!Q.isEmptyOrNull(VatCode)) {
                    this.form.DtList.Vatchange = VatCode

                    this.dtChange();

                }
            });





        }
        private dtChange() {
            var totalAmt = 0;
            var VatAmt = 0;

            for (var i of this.form.DtList.getItems()) {
                totalAmt += i.ItemAmt || 0;
                VatAmt += i.ItemVatAmt || 0;

            }

            if (this.form.VatFg.value == "1") {
                var a = this.form.DtList.getItems().map(o => o.VatRate)

                console.log(a)
                console.log(a.length)
                if (a.length > 0) {
                    var b = 0.00
                    b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0
                    if (b > 0) {
                        var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                        this.form.VatRate.value = x.VatRate
                        this.form.VatCode.value = x.VatCode
                        console.log("change" + b)
                    } else {
                        this.form.VatRate.value = 0;
                        this.form.VatCode.value = "V0"
                    }
                }
            } else {
                this.form.VatRate.value = 0
                this.form.VatCode.value = "N"
            }
            this.form.TotalAmt.value = totalAmt;
            this.form.DtList.TotalAmt_ = this.form.TotalAmt.value
            this.form.VatAmt.value = VatAmt;
            console.log("change" + VatAmt)
            // let totalAmt = this.form.TotalAmt.value;
            // let VatAmt = this.form.VatAmt.value;
            this.calcVat();
        }


        private calcDataOnGrid() {
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemAmt || 0;
                    VatAmt += i.ItemVatAmt || 0;

                }

                if (this.form.VatFg.value == "1") {
                    var a = this.form.DtList.getItems().map(o => o.VatRate)

                    console.log(a)
                    console.log(a.length)
                    if (a.length > 0) {
                        var b = 0.00
                        b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0
                        if (b > 0) {
                            var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                            this.form.VatRate.value = x.VatRate
                            this.form.VatCode.value = x.VatCode
                            console.log("change" + b)
                        } else {
                            this.form.VatRate.value = 0;
                            this.form.VatCode.value = "V0"
                        }
                    }
                } else {
                    this.form.VatRate.value = 0
                    this.form.VatCode.value = "N"
                }

                this.form.TotalAmt.value = totalAmt;
                this.form.DtList.TotalAmt_ = this.form.TotalAmt.value
                this.form.VatAmt.value = VatAmt;
                this.calcVat();

            });

            (this.form.DtList.view as any).onRowCountChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemAmt || 0;
                    VatAmt += i.ItemVatAmt || 0;

                }

                if (this.form.VatFg.value == "1") {
                    var a = this.form.DtList.getItems().map(o => o.VatRate)

                    console.log(a)
                    console.log(a.length)
                    if (a.length > 0) {
                        var b = 0.00
                        b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0
                        if (b > 0) {
                            var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                            this.form.VatRate.value = x.VatRate
                            this.form.VatCode.value = x.VatCode
                            console.log("change" + b)
                        } else {
                            this.form.VatRate.value = 0;
                            this.form.VatCode.value = "V0"
                        }
                    }
                } else {
                    this.form.VatRate.value = 0
                    this.form.VatCode.value = "N"
                }

                this.form.TotalAmt.value = totalAmt;
                this.form.DtList.TotalAmt_ = this.form.TotalAmt.value
                this.form.VatAmt.value = VatAmt;
                this.calcVat();

            });

        }
        private disamtalocate() {
            //20%,5%,200
            var discStr = this.form.DiscText.value;
            let a = discStr.split(",")
            console.log("before+" + this.form.TotalAmt.value)
            this.form.DtList.TotalAmt_ = this.form.TotalAmt.value

            var totalAmts = this.form.TotalAmt.value;
            var discamt = 0
            //var net = 0

            for (var po of a) {

                if (po.includes("%")) {
                    let a = po.replace("%", "");
                    let b = Number(a);
                    console.log(b)
                    let amt = totalAmts * b / 100
                    discamt = discamt + amt;
                    totalAmts = totalAmts - amt;
                } else {
                    let x = Number(po)
                    discamt = discamt + x
                    totalAmts = totalAmts - x;
                }

            }

            console.log("Lasttotal:" + totalAmts)
            console.log("DiscAmt:" + discamt)

            this.form.DiscAmt.value = discamt

            if (discamt >= 0) {

                this.form.DtList.DisAlocate = discamt;
            }

            this.dtChange();

        }

        private calcVat() {
            let totalAmt = this.form.TotalAmt.value;
            let VatAmt = this.form.VatAmt.value;
            let discamt = this.form.DiscAmt.value;
            let salev = this.form.SalesVatTypes.value

            this.form.NetAmt.value = totalAmt - discamt

            console.log("salev" + salev)

            if (totalAmt > 0) {
                if (salev == 'I') {
                    this.form.PurOrderAmt.value = totalAmt - discamt - VatAmt
                    this.form.NetExVat.value = totalAmt - discamt - VatAmt
                    this.form.NetTotalInVat.value = totalAmt - discamt
                } else {
                    this.form.PurOrderAmt.value = totalAmt - discamt + VatAmt
                    this.form.NetExVat.value = totalAmt - discamt
                    this.form.NetTotalInVat.value = totalAmt - discamt + VatAmt
                }
            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let send: Serenity.ToolButton =
                {
                    title: "Send Approve",
                    hint: "Send to approve",
                    separator: false,
                    cssClass: "button-sendapp",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;

                        this.disamtalocate();
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                                Q.confirm('ยืนยันส่งอนุมัติเอกสาร'
                                    , () => {
                                        this.form.SendForAppfg.value = "1";


                                        var options = this.getSaveOptions((respons2) => {

                                            if (this.isEditMode()) {
                                                var id1 = respons2.EntityId;
                                                if (id1 == null) {
                                                    id1 = this.get_entityId();
                                                }
                                                this.loadById(id1);
                                            }
                                            else {
                                                this.loadById(respons2.EntityId);
                                                // this.dialogClose();
                                            }

                                            this.showSaveSuccessMessage(respons2);


                                        });



                                        options.onError = function (respons2) {
                                            Q.alert(respons2.Error.Message);
                                        }

                                        Q.serviceCall(options);




                                    });


                            });

                            options.onError = function (response) {
                                Q.alert(response.Error.Message);
                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(send);

                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "SAVE",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;

                        if (this.isNew()) {
                            this.getNextNumber();
                        }
                        this.disamtalocate()


                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    this.loadById(id1);
                                }
                                else {
                                    if (this.isNew()) {
                                        this.dialogClose();
                                    } else {
                                        this.loadById(response.EntityId);
                                    }
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message.includes("Can't save record. There is another record")) {
                                    Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.SysDocNo.value
                                    var f = s.substring(0, 9)
                                    GeniuzPOS.Purchase.PoPurOrderService.GetNextNumber({
                                        Prefix: f,
                                        Length: 15
                                    }, response => {
                                        this.form.PurDocNo.value = response.Serial;
                                        self.form.SysDocNo.value = response.Serial;
                                    });
                                } else { Q.alert(response.Error.Message); }



                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(newSaveBtn);



                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            // this.doDelete(() => {

                            //     this.dialogClose();
                            // });
                            this.form.CancelFg.value = "1";
                            this.save((response) => {
                                this.dialogClose();
                            });

                        });
                    }
                };
                buttons.push(newDeleteBtn);


                let newCloseBtn: Serenity.ToolButton =
                {
                    title: Q.text("ปิดเอกสาร"),
                    hint: "Close Document",
                    separator: false,
                    cssClass: "closed-button",
                    icon: "fa fa-save",
                    onClick: (e) => {
                        Q.confirm('ยืนยันการปิดเอกสาร', () => {
                            // this.doDelete(() => {
    
                            //     this.dialogClose();
                            // });
                            this.form.CancelFg.value = "1";
                            this.form.UseFg.value = 1;
                            this.save((response) => {
                                this.dialogClose();
                            });
    
                        });
                    }
                };
                buttons.push(newCloseBtn);


            }

            let Editaddress: Serenity.ToolButton =
            {
                title: "Hide/Show address'",
                hint: "Edit address",
                separator: false,
                cssClass: "bt-editaddress",
                // icon: "fa fa-save",
                // hotkey: 'alt+x',
                onClick: (e) => {
                    if (this.hide == 1) {
                        this.hideadd(0);
                    } else {
                        this.hideadd(1);
                    }

                }
            };
            buttons.push(Editaddress);

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            let realocate: Serenity.ToolButton =
            {
                title: "",
                hint: "recal",
                cssClass: "recall",
                icon: "fa fa-undo-alt",

                onClick: (e) => {
                    this.disamtalocate()
                }
            };
            buttons.push(realocate);

            // let apply: Serenity.ToolButton =
            // {
            //     title: "",
            //     hint: "applyprintaddress",
            //     cssClass: "applyprint",
            //     icon: "fa fa-undo-alt",

            //     onClick: (e) => {

            //     }
            // };
            // buttons.push(realocate);

            let CallPR: Serenity.ToolButton =
            {
                title: "",
                hint: "call PR detail",
                cssClass: "callpr",
                icon: "fa fa-level-down-alt",

                onClick: (e) => {

                    let orderNo = this.form.RefDocNo1.value
                    if (!Q.isEmptyOrNull(orderNo)) {
                        let pp = this.form.Remark.value;
                        console.log(pp)

                        var id = Q.tryFirst(PoPurRequestRow.getLookup().items, x => x.SysDocNo == orderNo).SysDocNo;

                        PoPurRequestService.Retrieve(
                            {
                                EntityId: id
                            }, response => {
                                this.setHdDetails(response.Entity);
                                this.form.DtList.CallPR = this.form.RefDocNo1.value
                                this.disamtalocate();
                                Serenity.EditorUtils.setReadOnly(this.form.SalesVatTypes, true);
                                Serenity.EditorUtils.setReadOnly(this.form.POTypeFg, true);
                                Serenity.EditorUtils.setReadOnly(this.form.VatFg, true);
                                //  Serenity.EditorUtils.setReadOnly(this.form.SupplierId, true);
                                //this.calcVat();


                                if (pp.length > 0) {
                                    this.form.Remark.value = pp + "," + orderNo
                                } else {
                                    this.form.Remark.value = orderNo
                                }


                            }
                        );




                        // this.disamtalocate();




                    }
                    //ถ้า กดref เดิม จะต้องลบรายการเดิมออกแล้วอัพเดตตัวใหม่เข้าไป  ---ติดไว้ก่อน
                }
            };
            buttons.push(CallPR);


            // if(!this.isNew()){
            buttons.push(
                {
                    title: Q.text("PDf"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o text-red',
                    onClick: () => {
                        //var row = this.view.getRows();                        
                        // this.save((response) => {


                        // const self = this;
                        // var request = self as PoPurOrderPrintData;
                        const request: PoPurOrderPrintData = {};

                        request.SysDocNo = this.form.SysDocNo.value
                        request.Header = Q.tryFirst(PoPurOrderRow.getLookup().items, x => x.SysDocNo == this.form.SysDocNo.value)
                        let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)

                        if (fg != null) {
                            let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.form.ShopId.value)
                            request.BizName = s.ShopRegName
                            request.BizAddressLine1 = s.ShopRegAddressLine1
                            request.BizAddressLine2 = s.ShopRegAddressLine2
                            request.BizAddressLine3 = s.ShopRegAddressLine3
                            request.TaxId = s.ShopTaxId
                        } else {

                            let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                            request.BizName = q.BizName
                            request.BizAddressLine1 = q.TaxInvAddrLine1
                            request.BizAddressLine2 = q.TaxInvAddrLine2
                            request.BizAddressLine3 = q.TaxInvAddrLine3
                            request.TaxId = q.BizName
                        }
                        request.Supdata = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x => x.SupplId == this.form.SupplierId.value)
                        // request.Details = (PoPurInvoiceDtRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                        // const getPO = Q.first(PoPurInvoiceRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo);
                        let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)

                        if (p != null) {
                            let vp = window.location.href.replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/Purchase/PoPurOrderedit/" + this.entity.SysDocNo, "")
                            request.URLpic = ap + "/upload/" + p.ShopLogoOnFrontScreen
                        } else {
                            request.URLpic = "https://" + window.location.host + "/upload/info.jpg"
                        }
                        console.log(request)

                        var fgApp = 0;
                        let appsign = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 79 && x.SysFg > 0)
                        let lookupconsignfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 32 && x.SysFg > 0)
                        let c = this.form.ApproveFg.value;
                        if (lookupconsignfg != null) {
                            if (c == "1") {
                                fgApp = 0;
                            } else {
                                fgApp = 1;
                            }
                        } else {

                            if (c == "1" && appsign != null) {
                                fgApp = 3;
                                let namesign = Q.tryFirst(ListLastAppPurOrderRow.getLookup().items, x => x.SysDocNo == this.form.SysDocNo.value)
                                if (namesign != null) {

                                    request.AppDate = Q.formatDate(namesign.AppDate, "dd/MM/yyyy");
                                    request.AppName = namesign.DisplayName;
                                } else {
                                    fgApp = 0;
                                }
                            } else {
                                fgApp = 0;
                            }
                        }

                        console.log(request.AppDate)
                        console.log(request.AppName)



                        if (fgApp == 0) {

                            Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                            // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                        }
                        if (fgApp == 3) {

                            Q.postToService({ service: this.getService() + '/ExportAppSignPdf', request: request, target: '_blank' })
                            // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                        } else {
                            Q.warning("เอกสารนี้ยังไม่ผ่านการอนุมัติ โปรดทำการอนุมัติเอกสารก่อน")
                        }

                    }
                }
            );
            //  }
            return buttons;
        }

        public setHdDetails(details: PoPurRequestRow) {
            //hd
            this.form.ShipId.value = String(details.ShipId ?? '');
            this.form.ShipDate.value = details.ShipDate ?? '';
            this.form.WhsId.value = String(details.WhsId ?? '');
            this.form.ShipName.value = String(details.ShipName);
            this.form.ShipLineAddress1.value = String(details.ShipLineAddress1 ?? '');
            this.form.ShipLineAddress2.value = String(details.ShipLineAddress2 ?? '');
            this.form.ShipLineAddress3.value = String(details.ShipLineAddress3 ?? '');
            this.form.PayTermCode.value = String(details.PayTermCode ?? '');
            this.form.BranchCode.value = String(details.BranchCode ?? '');
            if (details.PayTermCode == "Cash") {
                this.form.CashOrTermfg.value = "0"
                // this.form.DueDate.valueAsDate = new Date(Date.now());
            } else {
                this.form.CashOrTermfg.value = "1"

            }
            this.form.POTypeFg.value = String(details.POTypeFg ?? '');

            this.form.VatFg.value = String(details.VatFg ?? '');
            let x = String(details.SalesVatTypes ?? '');

            if (!Q.isEmptyOrNull(x)) {
                console.log("oooo" + x);
                this.form.SalesVatTypes.value = x
                this.form.DtList.salevattype = x
                //this.form.DtList.salevatetype = this.form.SalesVatTypes.value
            }
            console.log(details.POTypeFg)

            //foot
            this.form.Remark.value = String(details.Remark ?? '');
            this.form.DiscText.value = String(details.DiscText ?? '');

            this.form.VatCode.value = String(details.VatCode ?? '');
            // 
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.syscuscheck();
            this.hideadd(1);
            this.toolbar.findButton('callpr').insertAfter(this.form.RefDocNo1.element)
            this.toolbar.findButton('recall').insertAfter(this.form.DiscText.element)

            this.form.DtList.myPassValue = this.form.SysDocNo.value
            this.form.DtList.supid = this.form.SupplierId.value
            this.form.DtList.whsid = this.form.WhsId.value
            this.form.DtList.salevattype = this.form.SalesVatTypes.value

            if (this.isNew()) {
                this.toolbar.findButton('closed-button').hide();
                this.form.RefDocNo1.set_readOnly(true);
                this.form.PayTermCode.set_readOnly(true);
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                this.form.ShopId.value = userId.ShopId
                this.form.DtList.shopid = userId.ShopId
                this.getNextNumber();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('delete-button').hide();
                // this.form.DtList._appfg = false

            } else {
                Serenity.EditorUtils.setReadOnly(this.form.SalesVatTypes, true);
                Serenity.EditorUtils.setReadOnly(this.form.POTypeFg, true);
            }





            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            if (this.entity.ApproveFg == 1 || this.entity.ApproveFg == 2 || this.entity.CancelFg == 1 || this.entity.SendForAppfg == 1) {
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                this.toolbar.findButton('button-save').toggleClass('disabled', true);
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);

                this.deleteButton.toggleClass('disabled', true);
                this.form.DtList.set_readOnly(true);
                this.form.RefDocNo1.getGridField().toggle(false);
                this.form.ConcatRefDocNo1.getGridField().toggle(true);
                // this.form.DtList._appfg = true
                this.appreadonly();
            } else {
                this.toolbar.findButton('closed-button').hide();
                this.toolbar.findButton('apply-changes-button').hide();
                // this.form.DtList._appfg = false

            }

        }
        // protected validateBeforeSave(): boolean {
        //     super.validateBeforeSave();
        //         this.disamtalocate();   
        //     return this.validateBeforeSave();
        // }
        protected getSaveEntity(): PoPurOrderRow {
            let entity = super.getSaveEntity();

            return entity;
        }


        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                //  console.log('User Id : ' + userId.ShopId);

                //  this.form.ShopId.value = userId.ShopId
                //  this.form.DtList.shopid = userId.ShopId
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "11").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Purchase.PoPurOrderService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.PurDocNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                });
            }

        }

        private appreadonly() {
            // this.form.PurDocNo.set_readOnly(true);
            Serenity.EditorUtils.setReadOnly(this.form.DocNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.SupplierId, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo1, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo2, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipId, true);
            Serenity.EditorUtils.setReadOnly(this.form.PayTermCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.SalesVatTypes, true);
            Serenity.EditorUtils.setReadOnly(this.form.POTypeFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipDate, true);

            Serenity.EditorUtils.setReadOnly(this.form.Remark, true);
            Serenity.EditorUtils.setReadOnly(this.form.DiscText, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);

            Serenity.EditorUtils.setReadOnly(this.form.ShipLineAddress1, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipLineAddress2, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipLineAddress3, true);
        }


        private syscuscheck() {

            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 3 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.SalesVatTypes.getGridField().toggle(true);
            } else {
                this.form.SalesVatTypes.getGridField().toggle(false);
            }

            let vatfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 64 && x.SysFg > 0)
            console.log(vatfg)
            if (vatfg != null) {
                this.form.VatFg.getGridField().toggle(true);
            } else {
                this.form.VatFg.getGridField().toggle(false);
            }

            let potype = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 68 && x.SysFg > 0)

            if (potype != null) {
                this.potypefg = 1;
                this.form.POTypeFg.getGridField().toggle(true);
            } else {
                this.potypefg = 0;
                this.form.POTypeFg.getGridField().toggle(false);
            }

            let docdate = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 27 && x.SysFg > 0)
            // console.log(vatfg)
            if (docdate != null) {
                Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            } else {

            }

            let pay = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 65 && x.SysFg > 0)

            if (pay != null) {
                this.paycode = 1;
            } else {
                this.paycode = 0;
            }

        }

        private hideadd(hided: number) {
            if (hided == 1) {
                this.form.ShipLineAddress1.getGridField().toggle(false);
                this.form.ShipLineAddress2.getGridField().toggle(false);
                this.form.ShipLineAddress3.getGridField().toggle(false);
                this.hide = 1
            } else {
                this.form.ShipLineAddress1.getGridField().toggle(true);
                this.form.ShipLineAddress2.getGridField().toggle(true);
                this.form.ShipLineAddress3.getGridField().toggle(true);
                this.hide = 0
            }
        }

        // declare private loadedState: string;
        // override initDialog() {
        //     super.initDialog();
        //     DialogUtils.pendingChangesConfirmation(this.domNode, () => this.getSaveState() != this.loadedState);
        // }

        // loadResponse(data: any) {
        //     super.loadResponse(data);
        //     this.loadedState = this.getSaveState();
        // }

        // getSaveState() {
        //     try {
        //         return JSON.stringify(this.getSaveEntity());
        //     }
        //     catch (e) {
        //         return null;
        //     }
        // }
    }
}